import { render, staticRenderFns } from "./help-composer.vue?vue&type=template&id=c676392c&scoped=true"
import script from "./help-composer.vue?vue&type=script&lang=js"
export * from "./help-composer.vue?vue&type=script&lang=js"
import style0 from "./help-composer.vue?vue&type=style&index=0&id=c676392c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c676392c",
  null
  
)

export default component.exports